import {clickEvent, customEvent} from "../../../webpack/modules/events";
import {showShareCartLink} from "../../../webpack/modules-optimized/cart";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

clickEvent('#cart .share-cart', true, function() {
    showShareCartLink();
    ga4TrackSimpleEvent(
        {
            event: 'checkout',
            step: 1,
            method: 'share_cart'
        }
    );
});

clickEvent('#share-cart-btn', true, function(element) {
    let input = document.querySelector('#share-cart-link');
    input.select();
    input.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(input.value).then(() => {
        element.classList.remove('btn-dark');
        element.classList.add('btn-success');
        let icon = element.querySelector('.fa-solid');
        if (icon) {
            icon.classList.remove('fa-copy');
            icon.classList.add('fa-check');
        }
    });
});

customEvent('hide.bs.offcanvas', '#cart', false, function() {
    ga4TrackSimpleEvent(
        {
            event: 'checkout',
            step: 1,
            method: 'close_cart'
        }
    );
});

customEvent('show.bs.offcanvas', '#cart', false, function() {
    ga4TrackSimpleEvent(
        {
            event: 'checkout',
            step: 1,
            method: 'show_cart'
        }
    );
});

clickEvent('#cart #paypal-button', true, function() {
    if(!localStorage.getItem('_tv_cookie_choice')){
        setCookieForADay('_tv_in_checkout', 'y');
    }
    ga4TrackSimpleEvent(
        {
            event: 'checkout',
            step: 1,
            method: 'paypal'
        }
    );
});

clickEvent('#cart #amazon-pay-button', true, function() {
    if(!localStorage.getItem('_tv_cookie_choice')){
        setCookieForADay('_tv_in_checkout', 'y');
    }
    ga4TrackSimpleEvent(
        {
            event: 'checkout',
            step: 1,
            method: 'amazon_pay'
        }
    );
});